export default __webpack_public_path__ + "static/media/BellSimple.505e04eb.svg";